export default __webpack_public_path__ + "static/media/GB.b8a0242a.svg";